/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # Product Reviews functionality

define('modules/Reviews/Reviews',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    function truncateDescriptions() {
        // review description truncation
        var descriptions = $('.reviewItem .description');
        if (descriptions && descriptions.length > 0) {
            descriptions.truncate({ max_length: 420, more: 'more', less: 'less' });
        }
    }

    function initRatingBreakdown() {
        var ratingBreakdown = $('.ratingBreakdown');
        ratingBreakdown.hide().css({ "position": 'static', "left": '0' });
        $('.ratingBreakdownTrigger').on('click', function (e) {
            e.preventDefault();
            ratingBreakdown.toggle();
        });
    };

    function initCommentCompose() {
        // review comment compose toggle
        $('.reviewsWrapper').on('click', '.reviewItem .commentReply', function (e) {
            e.preventDefault();
            $(this).closest('.reviewItem').find('.reviewCommentCompose:first').toggle();
        });
    };

    function initWriteReview() {
        // configures write review and read review buttons and visability
        $('[data-trigger-review=\'enable\']').on('click', function (e) {
            showWriteReview();
        });

        $('[data-trigger-review=\'disable\']').on('click', function (e) {
            hideWriteReview();
        });

        $('[data-trigger-review=\'toggle\']').on('click', function (e) {
            hideWriteReview();
        });
    };

    function showWriteReview() {
        // show write review
        $('#reviewsWrapper #reviewThankYou').remove();
        $('#writeReview').slideDown('fast');
        $('#reviewList').slideUp('fast');
        $(window).scrollTop($('#writeReview').offset().top - $(window).height() * 0.1);
        swapWriteRead();
    };

    function hideWriteReview() {
        // hide write review
        $('#writeReview').slideUp('fast');
        if (!$('.noReviewsWrapper').is(':visible')) {
            $('#reviewList').slideDown('fast');
        }

        if ($('[data-trigger-review=\'disable\']').is(':visible')) {
            swapWriteRead();
        }
    };

    function swapWriteRead() {
        // toggle visibility of write and read buttons that are side by side
        var writeButton = $('[data-trigger-review=\'enable\']').each(function () {
            if ($(this).next('[data-trigger-review=\'disable\']').length === 1) {
                $(this).toggle().next().toggle();
            }
        });
    };

    function initJumpToReview() {
        $('.jumpToReview').on('click', function (e) {
            e.preventDefault();
            var reviewId = $(e.currentTarget).data('tabid');
            //var tabid = e.attr(id);
            hideWriteReview();
            jumpToReview(reviewId);
        });
    };

    function jumpToReview(reviewId) {
        $(document).scrollTop($('#' + reviewId).offset().top);
    };

    function controlHasError(value, correspondingControlSelector, additionalValidation) {
        var controls = $(correspondingControlSelector).add($(correspondingControlSelector).find('label,input,textarea'));
        if (value.length === 0 || (typeof additionalValidation === 'function' && !additionalValidation(value))) {
            controls.addClass('formee-error');
            return true;
        }
        controls.removeClass('formee-error');
        return false;
    };

    function init() {
        truncateDescriptions();
        initCommentCompose();
        initJumpToReview();
        initWriteReview();
    };

    // public methods
    var Reviews = {
        init: init,
        truncateDescriptions: truncateDescriptions,
        showWriteReview: showWriteReview,
        hideWriteReview: hideWriteReview,
        jumpToReview: jumpToReview,
        controlHasError: controlHasError
    };

    Roc.Logger.debug('Reviews.js Loaded:', Reviews);

    // return public methods
    return Reviews;
});
